
export const ADMIN_ADD_PRODUCT_IDLE = "ADMIN_ADD_PRODUCT_IDLE";
export const adminAddProductIdle = () => ({
  type: ADMIN_ADD_PRODUCT_IDLE,
});

export const ADMIN_ADD_PRODUCT_REQUESTED = "ADMIN_ADD_PRODUCT_REQUESTED";
export const adminAddProductRequested = () => ({
  type: ADMIN_ADD_PRODUCT_REQUESTED,
});

export const ADMIN_ADD_PRODUCT_SUCCESS = "ADMIN_ADD_PRODUCT_SUCCESS";
export const adminAddProductSuccess = () => ({ 
  type: ADMIN_ADD_PRODUCT_SUCCESS, 
});

export const ADMIN_ADD_PRODUCT_ERROR = "ADMIN_ADD_PRODUCT_ERROR";
export const adminAddProductError = () => ({
  type: ADMIN_ADD_PRODUCT_ERROR,
}); 

 


export const ADMIN_DELETE_PRODUCT_IDLE = "ADMIN_DELETE_PRODUCT_IDLE";
export const adminDeleteProductIdle = () => ({
  type: ADMIN_DELETE_PRODUCT_IDLE,
});

export const ADMIN_DELETE_PRODUCT_REQUESTED = "ADMIN_DELETE_PRODUCT_REQUESTED";
export const adminDeleteProductRequested = () => ({
  type: ADMIN_DELETE_PRODUCT_REQUESTED,
});

export const ADMIN_DELETE_PRODUCT_SUCCESS = "ADMIN_DELETE_PRODUCT_SUCCESS";
export const adminDeleteProductSuccess = () => ({ 
  type: ADMIN_DELETE_PRODUCT_SUCCESS, 
});

export const ADMIN_DELETE_PRODUCT_ERROR = "ADMIN_DELETE_PRODUCT_ERROR";
export const adminDeleteProductError = () => ({
  type: ADMIN_DELETE_PRODUCT_ERROR,
});




export const ADMIN_UPDATE_PRODUCT_IDLE = "ADMIN_UPDATE_PRODUCT_IDLE";
export const adminUpdateProductIdle = () => ({
  type: ADMIN_UPDATE_PRODUCT_IDLE,
});

export const ADMIN_UPDATE_PRODUCT_REQUESTED = "ADMIN_UPDATE_PRODUCT_REQUESTED";
export const adminUpdateProductRequested = () => ({
  type: ADMIN_UPDATE_PRODUCT_REQUESTED,
});

export const ADMIN_UPDATE_PRODUCT_SUCCESS = "ADMIN_UPDATE_PRODUCT_SUCCESS";
export const adminUpdateProductSuccess = () => ({ 
  type: ADMIN_UPDATE_PRODUCT_SUCCESS, 
});

export const ADMIN_UPDATE_PRODUCT_ERROR = "ADMIN_UPDATE_PRODUCT_ERROR";
export const adminUpdateProductError = () => ({
  type: ADMIN_UPDATE_PRODUCT_ERROR,
});



export const ADMIN_ADD_TO_SLIDER_REQUESTED = "ADMIN_ADD_TO_SLIDER_REQUESTED";
export const adminAddToSliderRequested = () => ({
  type: ADMIN_ADD_TO_SLIDER_REQUESTED,
});

export const ADMIN_ADD_TO_SLIDER_SUCCESS = "ADMIN_ADD_TO_SLIDER_SUCCESS";
export const adminAddToSliderSuccess = () => ({ 
  type: ADMIN_ADD_TO_SLIDER_SUCCESS, 
});

export const ADMIN_ADD_TO_SLIDER_ERROR = "ADMIN_ADD_TO_SLIDER_ERROR";
export const adminAddToSliderError = () => ({
  type: ADMIN_ADD_TO_SLIDER_ERROR,
}); 


export const ADMIN_DEL_FROM_SLIDER_REQUESTED = "ADMIN_DEL_FROM_SLIDER_REQUESTED";
export const adminDelFromSliderRequested = () => ({
  type: ADMIN_DEL_FROM_SLIDER_REQUESTED,
});

export const ADMIN_DEL_FROM_SLIDER_SUCCESS = "ADMIN_DEL_FROM_SLIDER_SUCCESS";
export const adminDelFromSliderSuccess = () => ({ 
  type: ADMIN_DEL_FROM_SLIDER_SUCCESS, 
});

export const ADMIN_DEL_FROM_SLIDER_ERROR = "ADMIN_DEL_FROM_SLIDER_ERROR";
export const adminDelFromSliderError = () => ({
  type: ADMIN_DEL_FROM_SLIDER_ERROR,
}); 



export const ADMIN_UPDATE_SLIDER_REQUESTED = "ADMIN_UPDATE_SLIDER_REQUESTED";
export const adminUpdateSliderRequested = () => ({
  type: ADMIN_UPDATE_SLIDER_REQUESTED,
});

export const ADMIN_UPDATE_SLIDER_SUCCESS = "ADMIN_UPDATE_SLIDER_SUCCESS";
export const adminUpdateSliderSuccess = () => ({ 
  type: ADMIN_UPDATE_SLIDER_SUCCESS, 
});

export const ADMIN_UPDATE_SLIDER_ERROR = "ADMIN_UPDATE_SLIDER_ERROR";
export const adminUpdateSliderError = () => ({
  type: ADMIN_UPDATE_SLIDER_ERROR,
}); 